/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "မနေ့က",
        "-2": "တစ်နေ့က",
        "0": "ယနေ့",
        "1": "မနက်ဖြန်",
        "2": "သန်ဘက်ခါ",
        "future": {
          "other": "{0} ရက်အတွင်း"
        },
        "past": {
          "other": "ပြီးခဲ့သည့် {0} ရက်"
        }
      },
      "day-narrow": {
        "-1": "မနေ့က",
        "-2": "တစ်နေ့က",
        "0": "ယနေ့",
        "1": "မနက်ဖြန်",
        "2": "သန်ဘက်ခါ",
        "future": {
          "other": "{0} ရက်အတွင်း"
        },
        "past": {
          "other": "ပြီးခဲ့သည့် {0} ရက်"
        }
      },
      "day-short": {
        "-1": "မနေ့က",
        "-2": "တစ်နေ့က",
        "0": "ယနေ့",
        "1": "မနက်ဖြန်",
        "2": "သန်ဘက်ခါ",
        "future": {
          "other": "{0} ရက်အတွင်း"
        },
        "past": {
          "other": "ပြီးခဲ့သည့် {0} ရက်"
        }
      },
      "hour": {
        "0": "ဤအချိန်",
        "future": {
          "other": "{0} နာရီအတွင်း"
        },
        "past": {
          "other": "ပြီးခဲ့သည့် {0} နာရီ"
        }
      },
      "hour-narrow": {
        "0": "ဤအချိန်",
        "future": {
          "other": "{0} နာရီအတွင်း"
        },
        "past": {
          "other": "ပြီးခဲ့သည့် {0} နာရီ"
        }
      },
      "hour-short": {
        "0": "ဤအချိန်",
        "future": {
          "other": "{0} နာရီအတွင်း"
        },
        "past": {
          "other": "ပြီးခဲ့သည့် {0} နာရီ"
        }
      },
      "minute": {
        "0": "ဤမိနစ်",
        "future": {
          "other": "{0} မိနစ်အတွင်း"
        },
        "past": {
          "other": "ပြီးခဲ့သည့် {0} မိနစ်"
        }
      },
      "minute-narrow": {
        "0": "ဤမိနစ်",
        "future": {
          "other": "{0} မိနစ်အတွင်း"
        },
        "past": {
          "other": "ပြီးခဲ့သည့် {0} မိနစ်"
        }
      },
      "minute-short": {
        "0": "ဤမိနစ်",
        "future": {
          "other": "{0} မိနစ်အတွင်း"
        },
        "past": {
          "other": "ပြီးခဲ့သည့် {0} မိနစ်"
        }
      },
      "month": {
        "-1": "ပြီးခဲ့သည့်လ",
        "0": "ယခုလ",
        "1": "လာမည့်လ",
        "future": {
          "other": "{0} လအတွင်း"
        },
        "past": {
          "other": "ပြီးခဲ့သည့် {0} လ"
        }
      },
      "month-narrow": {
        "-1": "ပြီးခဲ့သည့်လ",
        "0": "ယခုလ",
        "1": "လာမည့်လ",
        "future": {
          "other": "{0} လအတွင်း"
        },
        "past": {
          "other": "ပြီးခဲ့သည့် {0} လ"
        }
      },
      "month-short": {
        "-1": "ပြီးခဲ့သည့်လ",
        "0": "ယခုလ",
        "1": "လာမည့်လ",
        "future": {
          "other": "{0} လအတွင်း"
        },
        "past": {
          "other": "ပြီးခဲ့သည့် {0} လ"
        }
      },
      "nu": ["mymr"],
      "quarter": {
        "-1": "ပြီးခဲ့သည့် သုံးလပတ်",
        "0": "ယခု သုံးလပတ်",
        "1": "လာမည့် သုံးလပတ်",
        "future": {
          "other": "သုံးလပတ်ကာလ {0} အတွင်း"
        },
        "past": {
          "other": "ပြီးခဲ့သည့် သုံးလပတ်ကာလ {0} ခုအတွင်း"
        }
      },
      "quarter-narrow": {
        "-1": "ပြီးခဲ့သောသုံးလပတ်",
        "0": "ယခုသုံးလပတ်",
        "1": "နောက်လာမည့်သုံးလပတ်",
        "future": {
          "other": "သုံးလပတ်ကာလ {0} ခုအတွင်း"
        },
        "past": {
          "other": "ပြီးခဲ့သည့် သုံးလပတ်ကာလ {0} ခုအတွင်း"
        }
      },
      "quarter-short": {
        "-1": "ပြီးခဲ့သောသုံးလပတ်",
        "0": "ယခုသုံးလပတ်",
        "1": "နောက်လာမည့်သုံးလပတ်",
        "future": {
          "other": "သုံးလပတ်ကာလ {0} ခုအတွင်း"
        },
        "past": {
          "other": "ပြီးခဲ့သည့် သုံးလပတ်ကာလ {0} ခုအတွင်း"
        }
      },
      "second": {
        "0": "ယခု",
        "future": {
          "other": "{0} စက္ကန့်အတွင်း"
        },
        "past": {
          "other": "ပြီးခဲ့သည့် {0} စက္ကန့်"
        }
      },
      "second-narrow": {
        "0": "ယခု",
        "future": {
          "other": "{0} စက္ကန့်အတွင်း"
        },
        "past": {
          "other": "ပြီးခဲ့သည့် {0} စက္ကန့်"
        }
      },
      "second-short": {
        "0": "ယခု",
        "future": {
          "other": "{0} စက္ကန့်အတွင်း"
        },
        "past": {
          "other": "ပြီးခဲ့သည့် {0} စက္ကန့်"
        }
      },
      "week": {
        "-1": "ပြီးခဲ့သည့် သီတင်းပတ်",
        "0": "ယခု သီတင်းပတ်",
        "1": "လာမည့် သီတင်းပတ်",
        "future": {
          "other": "{0} ပတ်အတွင်း"
        },
        "past": {
          "other": "ပြီးခဲ့သည့် {0} ပတ်"
        }
      },
      "week-narrow": {
        "-1": "ပြီးခဲ့သည့် သီတင်းပတ်",
        "0": "ယခု သီတင်းပတ်",
        "1": "လာမည့် သီတင်းပတ်",
        "future": {
          "other": "{0} ပတ်အတွင်း"
        },
        "past": {
          "other": "ပြီးခဲ့သည့် {0} ပတ်"
        }
      },
      "week-short": {
        "-1": "ပြီးခဲ့သည့် သီတင်းပတ်",
        "0": "ယခု သီတင်းပတ်",
        "1": "လာမည့် သီတင်းပတ်",
        "future": {
          "other": "{0} ပတ်အတွင်း"
        },
        "past": {
          "other": "ပြီးခဲ့သည့် {0} ပတ်"
        }
      },
      "year": {
        "-1": "ယမန်နှစ်",
        "0": "ယခုနှစ်",
        "1": "လာမည့်နှစ်",
        "future": {
          "other": "{0} နှစ်အတွင်း"
        },
        "past": {
          "other": "ပြီးခဲ့သည့် {0} နှစ်"
        }
      },
      "year-narrow": {
        "-1": "ယမန်နှစ်",
        "0": "ယခုနှစ်",
        "1": "လာမည့်နှစ်",
        "future": {
          "other": "{0} နှစ်အတွင်း"
        },
        "past": {
          "other": "ပြီးခဲ့သည့် {0} နှစ်"
        }
      },
      "year-short": {
        "-1": "ယမန်နှစ်",
        "0": "ယခုနှစ်",
        "1": "လာမည့်နှစ်",
        "future": {
          "other": "{0} နှစ်အတွင်း"
        },
        "past": {
          "other": "ပြီးခဲ့သည့် {0} နှစ်"
        }
      }
    },
    "locale": "my"
  });
}